module.exports = __webpack_public_path__ + "img/z-idcardbg1.55183fa8.png";